
import modal from './modal.vue'

export default {
	name: 'Tip',
	components: {
		modal
	},
	props: {
		text: {
			type: String,
		},
		description: {
			type: String,
		}
	},
	data() {
		return {
			modalVisible: false
		}
	},
	methods: {
		toggleModal: function(boo) {
			this.$data.modalVisible = !!boo;
		}
	}
}
